import { render, staticRenderFns } from "./PhoneTableEdit.vue?vue&type=template&id=27d2ab1f&scoped=true"
import script from "./PhoneTableEdit.vue?vue&type=script&lang=js"
export * from "./PhoneTableEdit.vue?vue&type=script&lang=js"
import style0 from "./PhoneTableEdit.vue?vue&type=style&index=0&id=27d2ab1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d2ab1f",
  null
  
)

export default component.exports